export const DB_CONFIG = {
  apiKey: 'AIzaSyBVR-nzQ-bz_72GMN0CsXdRkgWcHGAkPPQ',
  authDomain: 'memory-game-6cdcc.firebaseapp.com',
  databaseURL: 'https://memory-game-6cdcc.firebaseio.com',
  projectId: 'memory-game-6cdcc',
  storageBucket: 'memory-game-6cdcc.appspot.com',
  messagingSenderId: '581211740989',
  appId: '1:581211740989:web:50ff92b7d5f9bd0066c354',
};
